import GhostBar from "../GhostBar";

const GhostPrivateLayout = () => {
  return (
    <aside className="left-sidebar">
      <div className="sidebar-content">
        {/* Section 1: Tax Filing */}
        <div className="sidebar-section">
          <GhostBar
            width="60px"
            height="12px"
            style={{ marginBottom: "15px" }}
          />{" "}
          {/* Section Title */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              padding: "10px 0",
            }}
          >
            <GhostBar width="24px" height="24px" circle />
            <GhostBar width="100px" height="14px" />
          </div>
        </div>

        {/* Section 2: Financial Insights */}
        <div className="sidebar-section">
          <GhostBar
            width="80px"
            height="12px"
            style={{ marginBottom: "15px" }}
          />
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              padding: "10px 0",
            }}
          >
            <GhostBar width="24px" height="24px" circle />
            <GhostBar width="110px" height="14px" />
          </div>
        </div>

        {/* Section 3: Engagement */}
        <div className="sidebar-section">
          <GhostBar
            width="70px"
            height="12px"
            style={{ marginBottom: "15px" }}
          />
          {[1, 2, 3].map((i) => (
            <div
              key={i}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                padding: "10px 0",
              }}
            >
              <GhostBar width="24px" height="24px" circle />
              <GhostBar width={i === 2 ? "120px" : "90px"} height="14px" />
            </div>
          ))}
        </div>

        {/* Section 4: Help & Support */}
        <div className="sidebar-section">
          <GhostBar
            width="80px"
            height="12px"
            style={{ marginBottom: "15px" }}
          />
          {[1, 2].map((i) => (
            <div
              key={i}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                padding: "10px 0",
              }}
            >
              <GhostBar width="24px" height="24px" circle />
              <GhostBar width="100px" height="14px" />
            </div>
          ))}
        </div>

        {/* Footer Socials */}
        <hr className="separator-white" style={{ margin: "20px 0" }} />
        <div style={{ display: "flex", gap: "15px", padding: "0 5px" }}>
          <GhostBar width="20px" height="20px" circle />
          <GhostBar width="20px" height="20px" circle />
          <GhostBar width="20px" height="20px" circle />
        </div>
      </div>
    </aside>
  );
};

export default GhostPrivateLayout;
